<template>
  <v-application>
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="item"
          :itemsView="itemsView"
          itemsMark
          v-bind:importItem="importClick"
          v-bind:headers="headers"
          v-bind:data="data"
          v-bind:remove="remove"
          v-bind:num-pages="total"
          v-bind:download="download()"
          v-bind:add_button_name="'add_item'"
          v-model="page"
          v-bind:limit="limit"
          v-bind:all_categories="all_categories"
          v-bind:fetchCategories="fetchCategories"
          @change-pagination="changePagination"
          @change-limit="changeLimit"
          :loading_items_table_data="data_loading"
          :oneService="oneService"
          :has_variant="has_variant"
          @show-edit-cost="showEditCost"
          @edit-item-cost="editItemCost"
          @show-edit-price="showEditPrice"
          @edit-item-price="editItemPrice"
          @show-edit-price1="showEditPrice1"
          @edit-item-price1="editItemPrice1"
          @show-edit-price2="showEditPrice2"
          @edit-item-price2="editItemPrice2"
          @show-edit-price3="showEditPrice3"
          @edit-item-price3="editItemPrice3"
          @show-edit-from1="showEditFrom1"
          @edit-item-from1="editItemFrom1"
          @show-edit-from2="showEditFrom2"
          @edit-item-from2="editItemFrom2"
          @show-edit-from3="showEditFrom3"
          @edit-item-from3="editItemFrom3"
          @show-edit-in-stock="showEditInStock"
          @edit-item-in-stock="editItemInStock"
          @edit-item-category="editItemCategory"
          @open-variants="openVariants"
          @open-variant-dialog="openVariantDialogDetail"
          no-delete
        >
          <template #top>
            <v-combobox
              v-if="!search_text"
              v-model="store"
              :label="$t(`stores`)"
              v-bind:items="stores"
              item-text="name"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="category"
              :label="$t(`category`)"
              v-bind:items="all_top_categories"
              item-text="name"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="supplier"
              :label="$t(`supplier`)"
              v-bind:items="all_suppliers_"
              item-text="supplier_name"
              hide-details
              class="mx-1"
            />
            <v-combobox
              v-if="!search_text"
              v-model="stock"
              :label="$t(`stock_alert`)"
              v-bind:items="stocks"
              hide-details
              class="mx-1"
            />
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                :autofocus="search_field"
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), update_items();
                  }
                "
                @change="update_items()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <v-menu left offset-y min-width="150" max-width="150">
              <template #activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-card tile class="py-2">
                <v-btn text @click="checkProcessAndOpenDialog" class="ml-3">
                  <v-icon> mdi-dots-vertical </v-icon>{{ "pricing" }}
                </v-btn>
                <v-btn text @click="downloadItemsExcel" class="ml-3 mt-2">
                  <v-icon> mdi-download </v-icon>{{ "excel" }}
                </v-btn>
              </v-card>
            </v-menu>
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
    <v-variant-detail-dialog
      v-bind:variant_detail_dialog="variant_detail_dialog"
      v-bind:updateItemVariant="updateItemVariant"
      v-bind:updateItemVariantActionGlobal="updateItemVariantActionGlobal"
      v-bind:closeVariantDialog="closeVariantDialog"
      v-bind:current_item="current_item"
      v-bind:moneyOptions="moneyOptions"
      v-bind:services_headers="services_headers"
      v-bind:option_names="option_names"
      v-bind:variant_dialog_error="variant_dialog_error"
      v-bind:variant_dialog_error_text="variant_dialog_error_text"
    ></v-variant-detail-dialog>

    <v-dialog
      v-model="edit_prices_all_dialog"
      :width="800"
      persistent
      v-if="access.item_mark_edit"
    >
      <v-card>
        <v-card-title>{{ $t("pricing") }}</v-card-title>
        <v-card-text>
          <v-layout px-2 row>
            <v-flex md6 px-2>
              <v-autocomplete
                v-model="first_service"
                :label="$t('source_store')"
                :items="price_services"
                item-text="name"
                item-value="_id"
              />
            </v-flex>

            <v-flex md6 px-2>
              <v-autocomplete
                v-model="second_service"
                :label="$t('destination_store')"
                :items="price_services"
                item-value="_id"
                item-text="name"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="
              edit_prices_all_dialog = false;
              first_service = null;
              second_service = null;
            "
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            text
            color="primary"
            :disabled="disableConfirm"
            @click="setServicePrices"
            >{{ $t("confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="prices_all_dialog_processing" :width="50">
      <v-card :width="50" :height="50" class="ma-0 pa-0">
        <v-container fill-height fluid class="ma-0 pa-0">
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <v-col class="ma-0 pa-0 ml-2">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="proccesDialog" max-width="400px">
      <v-card>
        <v-list-item-action style="width: 338px; padding-left: 40px">
          <v-progress-linear
            :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
            background-color="white"
            height="10"
            style="border: 1px solid rgba(0, 0, 0, 0.26)"
            v-bind:value="excel_dowload_proccess"
            striped
          />
          <v-list-item-action-text
            >{{ $t("download") }}
            {{ excel_dowload_proccess.toFixed() + " %" }}
          </v-list-item-action-text>
        </v-list-item-action>
      </v-card>
    </v-dialog>
  </v-application>
</template>

<script>
import Services from "../../mixins/services";
import Categories from "../../mixins/items/categories";
import ItemsMixin from "../../mixins/items/item";
import ItemVariantDialog from "../../mixins/items/item-variant-dialog";
import Suppliers from "../../mixins/inventory/supplier";
import fileSaver from "file-saver";
import xlsx from "xlsx";
const AllSuppliers = Object.assign(
  { ...Suppliers },
  {
    mounted() {
      this.get_all_suppliers();
    },
  }
);
export default {
  name: "MarkItems",
  mixins: [Services, Categories, ItemsMixin, ItemVariantDialog, AllSuppliers],
  data: () => ({
    headers: [
      { text: "Item name", value: "name", align: "left", width: 100 },
      { text: "Category", value: "category_name" },
      { text: "Price", value: "price" },
      { text: "Cost", value: "cost" },
      { text: "In stock", value: "in_stock", align: "right" },
    ],
    data: [],
    stocks: [
      { text: "All items", value: "all" },
      { text: "Low stock", value: "low" },
      { text: "Out of stock", value: "out" },
    ],
    user: null,
    stock: null,
    page: 1,
    limit: 10,
    data_loading: false,
    numPages: 1,
    total: 0,
    has_variant: false,
    search_text: false,
    search: "",
    showItem: null,
    search_field: false,
    itemsView: true,
    edit_prices_all_dialog: false,
    prices_all_dialog_processing: false,
    first_service: null,
    second_service: null,
    data_total: 0,
    excel_dowload_proccess: 0,
    proccesDialog: false,
  }),
  computed: {
    oneService() {
      return this.store && this.store._id != "";
    },
    price_services() {
      if (!(this.stores instanceof Array)) {
        return [];
      }
      const services = [];
      for (const s of this.stores) {
        if (s._id) {
          services.push(s);
        }
      }
      return services;
    },
    disableConfirm() {
      if (!this.first_service) return true;
      if (!this.second_service) return true;
      if (this.first_service === this.second_service) return true;
      return false;
    },
  },
  beforeMount() {
    this.page = this.$store.state.items_current_page;
    this.store = this.$store.state.items_current_service;
    if (this.store && !this.store.name) {
      this.store.name = this.$t("all_stores");
    }
    this.supplier = this.$store.state.supplier1;
    if (this.supplier && !this.supplier.supplier_name) {
      this.supplier.supplier_name = this.$t("all_suppliers");
    }
    this.category = this.$store.state.category1;
    if (this.category && !this.category.name) {
      this.category.name = this.$t("all_categories");
    }
    this.access = this.$store.state.access;
    this.features = this.$store.state.feature;
  },
  methods: {
    async downloadItemsExcel() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const excel_limit = 1000;
      let all_data = [];
      const page_count = Math.ceil(this.data_total / excel_limit)*10;
      for (let excel_page = 1; excel_page <= page_count; excel_page++) {
        const items = this.$communicator.then(
          this,
          await this.$communicator("list_of_items", {
            arguments: [excel_limit, excel_page],
            params: {
              service: this.store && this.store._id != "" ? this.store._id : "",
              category: this.category._id,
              stock: this.stock.value,
              name: this.search_text ? this.search : "",
              supplier_id:
                this.supplier && this.supplier._id ? this.supplier._id : "",
            },
          })
        );
        this.excel_dowload_proccess = (excel_page / page_count) * 100;
        all_data.push(...items?.data);
      }
      const item = all_data.map((itm) => {
        const prices = {};
        if (itm?.prices?.length) {
          for (let i = 0; i < itm?.prices?.length; i++) {
            prices[`From${i + 1}`] =
              itm.prices[i] && itm.prices[i].from ? itm.prices[i].from : 0;
            prices[`Price${i + 1}`] =
              itm.prices[i] && itm.prices[i].price ? itm.prices[i].price : 0;
          }
        }
        if (!itm?.prices?.length && itm.price) {
          for (let i = 0; i < 3; i++) {
            prices[`From${i + 1}`] = 0;
            prices[`Price${i + 1}`] = itm.price;
          }
        }

        return {
          Sku: itm.sku,
          Name: itm.name,
          barcode: itm.barcode.reduce(function (currentSum, currentNumber) {
            return currentSum + currentNumber + ", ";
          }, ""),
          Cost: Math.round(itm.cost * 100) / 100,
          In_stock: itm.in_stock,
          ...prices,
        };
      });
      this.proccesDialog = false;
      const ws = xlsx.utils.json_to_sheet(item);
      const max_width = item.reduce((w, r) => Math.max(w, r.Name.length), 5);
      ws["!cols"] = [{}, { wch: max_width }, { wch: 25 }];
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "ItemMark.xlsx");
    },
    printLabel() {
      // window.location.href = "/items/create-label";
      this.$router.push("/items/create-label");
    },
    importClick() {
      this.$router.push("/items/import?org=" + this.user.organization);
    },
    // exportClicked() {
    //   "/goods/sales/export/:organization/:name";
    // },
    download() {
      if (this.user) {
        return (
          "goods/sales/export/" + this.user.organization + "/exported_items.csv"
        );
      } else {
        return "";
      }
    },
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    changePagination(page) {
      this.page = page;
      this.update_items();
    },
    changeLimit(limit) {
      this.limit = limit;
      this.update_items();
    },
    showEditCost(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_cost = state;
        } else {
          this.data[i].show_edit_cost = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemCost(id, cost) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
        }
        this.data[i].show_edit_cost = false;
      }
      const res = await this.update_goods_sales(id, {
        cost: cost,
        category: this.data[index].category,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].cost =
          typeof cost != "number"
            ? Number(cost).toLocaleString()
            : cost.toLocaleString();
        this.data.push({});
        this.data.pop();
      }
    },
    showEditPrice(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_price = state;
        } else {
          this.data[i].show_edit_price = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemPrice(id, price) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          this.data[i].price = price;
        }
        this.data[i].show_edit_price = false;
      }
      const res = await this.update_goods_sales(id, {
        price: price,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].price =
          typeof price != "number"
            ? Number(price).toLocaleString()
            : price.toLocaleString();
        this.data.push({});
        this.data.pop();
      }
    },
    showEditPrice1(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_price1 = state;
        } else {
          this.data[i].show_edit_price1 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemPrice1(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: this.data[i].from1,
              price: price == "" ? 0 : price,
            },
            {
              from: this.data[i].from2,
              price:
                typeof this.data[i].price2 == typeof 5
                  ? this.data[i].price2
                  : 0,
            },
            {
              from: this.data[i].from3,
              price:
                typeof this.data[i].price3 == typeof 5
                  ? this.data[i].price3
                  : 0,
            },
          ];
        }
        this.data[i].show_edit_price1 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].price1 = price != "" ? +price : 0;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditPrice2(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_price2 = state;
        } else {
          this.data[i].show_edit_price2 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemPrice2(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: this.data[i].from1,
              price:
                typeof this.data[i].price1 == typeof 5
                  ? this.data[i].price1
                  : 0,
            },
            {
              from: this.data[i].from2,
              price: price == "" ? 0 : price,
            },
            {
              from: this.data[i].from3,
              price:
                typeof this.data[i].price3 == typeof 5
                  ? this.data[i].price3
                  : 0,
            },
          ];
        }
        this.data[i].show_edit_price2 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].price2 = price != "" ? +price : 0;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditPrice3(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_price3 = state;
        } else {
          this.data[i].show_edit_price3 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemPrice3(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: this.data[i].from1,
              price:
                typeof this.data[i].price1 == typeof 5
                  ? this.data[i].price1
                  : 0,
            },
            {
              from: this.data[i].from2,
              price:
                typeof this.data[i].price2 == typeof 5
                  ? this.data[i].price2
                  : 0,
            },
            {
              from: this.data[i].from3,
              price: price == "" ? 0 : price,
            },
          ];
        }
        this.data[i].show_edit_price3 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].price3 = price != "" ? +price : 0;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditFrom1(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_from1 = state;
        } else {
          this.data[i].show_edit_from1 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemFrom1(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: price,
              price: this.data[i].price1,
            },
            {
              from: this.data[i].from2,
              price: this.data[i].price2,
            },
            {
              from: this.data[i].from3,
              price: this.data[i].price3,
            },
          ];
        }
        this.data[i].show_edit_from1 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].from1 = price;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditFrom2(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_from2 = state;
        } else {
          this.data[i].show_edit_from2 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemFrom2(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: this.data[i].from1,
              price: this.data[i].price1,
            },
            {
              from: price,
              price: this.data[i].price2,
            },
            {
              from: this.data[i].from3,
              price: this.data[i].price3,
            },
          ];
        }
        this.data[i].show_edit_from2 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].from2 = price;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditFrom3(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_from3 = state;
        } else {
          this.data[i].show_edit_from3 = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemFrom3(id, price) {
      let index = null;
      let prices = [];
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
          prices = [
            {
              from: this.data[i].from1,
              price: this.data[i].price1,
            },
            {
              from: this.data[i].from2,
              price: this.data[i].price2,
            },
            {
              from: price,
              price: this.data[i].price3,
            },
          ];
        }
        this.data[i].show_edit_from3 = false;
      }
      const res = await this.update_goods_sales(id, {
        prices: prices,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].from3 = price;
        this.data.push({});
        this.data.pop();
      }
    },
    showEditInStock(id, state) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          this.data[i].show_edit_in_stock = state;
        } else {
          this.data[i].show_edit_in_stock = false;
        }
      }
      this.data.push({});
      this.data.pop();
    },
    async editItemInStock(id, in_stock) {
      in_stock = +in_stock;
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
        }
        this.data[i].show_edit_in_stock = false;
      }
      this.showItem = this.data[index];
      const res = await this.update_goods_sales(id, {
        in_stock: in_stock,
        service: this.store._id,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].in_stock = in_stock;
        this.showItem = this.data[index];
        this.data.push({});
        this.data.pop();
      }
    },
    async editItemCategory(id, category) {
      let index = null;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i]._id == id) {
          index = i;
        }
      }
      const res = await this.update_goods_sales(id, {
        category: category.id,
        category_name: category.name,
      });
      if (res && res.data && res.data.statusCode == 200) {
        this.data[index].category_name = category.name;
        this.data[index].category = category.id;
        this.data.push({});
        this.data.pop();
      }
    },
    async openVariants(item, state) {
      this.data_loading = true;
      let index = null;
      const data = [];
      for (let i = 0; i < this.data.length; i++) {
        data.push(this.data[i]);
        if (this.data[i]._id == item._id) {
          index = i;
          break;
        }
      }
      if (state) {
        const res = await this.get_item_variants({
          item_id: item._id,
          services: this.store && this.store._id != "" ? [this.store._id] : [],
        });
        if (res && res.data && res.data.statusCode == 200) {
          data[index].open_variants = true;
          const res_data = res.data.data;
          for (let i = 0; i < res_data.length; i++) {
            res_data[i].cost = Math.round(res_data[i].cost).toLocaleString();
            res_data[i].price = Math.round(res_data[i].price).toLocaleString();
            data.push(res_data[i]);
          }
        }
        for (let i = index + 1; i < this.data.length; i++) {
          data.push(this.data[i]);
        }
      } else {
        data[index].open_variants = false;
        let k = null;
        for (let i = index + 1; i < this.data.length; i++) {
          if (this.data[i].item_type == "item") {
            k = i;
            break;
          }
        }
        if (k) {
          for (let i = k; i < this.data.length; i++) {
            data.push(this.data[i]);
          }
        }
      }
      this.data = data;
      this.data_loading = false;
    },
    async remove(items) {
      var indices = [];
      for (const index in items) {
        indices.push(items[index]._id);
      }
      await this.$communicator("remove_items", {
        params: {
          indexes: indices,
        },
      });
      this.update_items();
    },
    async update_items() {
      this.data_loading = true;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_items", {
          arguments: [this.limit, this.page],
          params: {
            service: this.store && this.store._id != "" ? this.store._id : "",
            category: this.category._id,
            stock: this.stock.value,
            name: this.search_text ? this.search : "",
            supplier_id:
              this.supplier && this.supplier._id ? this.supplier._id : "",
          },
        })
      );
      this.data_total = items.total;
      if (items) {
        this.total = items.page;
        var has_variant = false;
        // var stock_status = false;
        for (let i = 0; i < items.data.length; i++) {
          has_variant = has_variant || items.data[i].has_variants;
          if (this.store && this.store._id != "") {
            items.data[i].one_service = true;
          }
          if (typeof items.data[i].prices != typeof []) {
            items.data[i].prices = [];
          }
          if (items.data[i].prices.length == 0) {
            items.data[i].prices = [
              {
                from: 0,
                price: items.data[i].price,
              },
              {
                from: 0,
                price: items.data[i].price,
              },
              {
                from: 0,
                price: items.data[i].price,
              },
            ];
          }
          if (items.data[i].prices[0]) {
            items.data[i].price1 = items.data[i].prices[0].price;
          } else {
            items.data[i].price1 = items.data[i].price
              ? items.data[i].price
              : 0;
          }
          if (items.data[i].prices[1]) {
            items.data[i].price2 = items.data[i].prices[1].price;
          } else {
            items.data[i].price2 = items.data[i].price
              ? items.data[i].price
              : 0;
          }
          if (items.data[i].prices[2]) {
            items.data[i].price3 = items.data[i].prices[2].price;
          } else {
            items.data[i].price3 = items.data[i].price
              ? items.data[i].price
              : 0;
          }
          if (items.data[i].prices[0]) {
            items.data[i].from1 = items.data[i].prices[0].from;
          } else {
            items.data[i].from1 = 0;
          }
          if (items.data[i].prices[1]) {
            items.data[i].from2 = items.data[i].prices[1].from;
          } else {
            items.data[i].from2 = 0;
          }
          if (items.data[i].prices[2]) {
            items.data[i].from3 = items.data[i].prices[2].from;
          } else {
            items.data[i].from3 = 0;
          }
        }
        this.has_variant = has_variant;
        this.data = items.data;
        this.numPages = items.page;
      }
      this.data_loading = false;
    },
    async checkProcessAndOpenDialog() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("pricing_process_check")
      );
      if (!result || result.processing) {
        this.prices_all_dialog_processing = true;
        return;
      }
      this.edit_prices_all_dialog = true;
    },
    async setServicePrices() {
      const result = await this.$communicator("set_service_prices", {
        params: {
          first_service_id: this.first_service,
          second_service_id: this.second_service,
        },
      });
      if (result) {
        this.prices_all_dialog_processing = true;
        this.edit_prices_all_dialog = false;
        this.first_service = null;
        this.second_service = null;
      }
    },
  },
  watch: {
    category() {
      if (this.category && this.category._id != "") {
        this.page = 1;
      }
      this.update_items();
    },
    supplier() {
      if (this.supplier && this.supplier._id != "") {
        this.page = 1;
      }
      this.update_items();
    },
    store() {
      this.$store.commit("setItemsService", this.store);
      this.update_items();
    },
    page() {
      this.$store.commit("setItemsPage", this.page);
    },
    limit() {
      this.$store.commit("setItemsLimit", this.limit);
    },
    stock() {
      if (this.stock && this.stock.value != "all") {
        this.page = 1;
      }
      this.update_items();
    },
    all_top_categories() {
      if (
        this.all_top_categories &&
        this.all_top_categories.length > 0 &&
        this.all_top_categories[0]._id != ""
      ) {
        this.all_top_categories = [
          { name: this.$t("all_categories"), _id: "" },
        ].concat(this.all_top_categories);
      }
    },
    prices_all_dialog_processing() {
      if (this.prices_all_dialog_processing) {
        this.prices_all_dialog_processing_time = new Date().getTime();
        setTimeout(() => {
          const current_time = new Date().getTime();
          if (current_time - this.prices_all_dialog_processing_time > 3500) {
            this.prices_all_dialog_processing = false;
          }
        }, 4000);
      }
    },
  },
  mounted() {
    this.headers = [
      {
        text: this.$t(`item_name`),
        value: "name",
        align: "left",
        sortable: false,
        available: true,
      },
      // {
      //   text: this.$t(`barcode`),
      //   value: "barcode",
      //   sortable: false,
      // },
      {
        text: this.$t(`from`),
        value: "from1",
        align: "right",
        sortable: false,
        available: true,
      },
      {
        text: this.$t(`price`),
        value: "price1",
        align: "right",
        sortable: false,
        available: true,
      },
      // {
      //   text: this.$t(`margin`),
      //   value: "margin1",
      //   align: "right",
      //   sortable: false,
      // },
      {
        text: this.$t(`from`),
        value: "from2",
        align: "right",
        sortable: false,
        available: true,
      },
      {
        text: this.$t(`price`),
        value: "price2",
        align: "right",
        sortable: false,
        available: true,
      },
      // {
      //   text: this.$t(`margin`),
      //   value: "margin2",
      //   align: "right",
      //   sortable: false,
      // },
      {
        text: this.$t(`from`),
        value: "from3",
        align: "right",
        sortable: false,
        available: true,
      },
      {
        text: this.$t(`price`),
        value: "price3",
        align: "right",
        sortable: false,
        available: true,
      },
      // {
      //   text: this.$t(`margin`),
      //   value: "margin3",
      //   align: "right",
      //   sortable: false,
      // },
      {
        text: this.$t(`cost`),
        value: "cost",
        align: "right",
        width: 120,
        sortable: false,
        available: true,
      },
      {
        text: this.$t(`in_stock`),
        value: "in_stock",
        align: "right",
        width: 80,
        sortable: false,
        available: true,
      },
    ];
    this.stocks = [
      { text: this.$t("all_categories"), value: "all", available: true },
      { text: this.$t("positive"), value: "positive" , available: true},
      { text: this.$t("low_stock"), value: "low" , available: true},
      { text: this.$t("equal_to_zero"), value: "zero" , available: true},
      { text: this.$t("out_of_stock"), value: "out", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.stock = this.stocks[0];
    this.update_items();
    this.getTopCategories();
    this.user = this.$store.state.user;
    this.category = { name: this.$t("all_categories"), _id: "" };
  },
};
</script>
